import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import Article from './Article.jsx';
import Loader from '../Loader.jsx';
import NoMatch from '../404/NoMatch.jsx';
import VideoSummaries from './VideoSummaries';

const mapStateToProps = state => ({
  routeParams: state.routeParams,
  mainArticle: _.get(state, 'dataSources.article'),
  relatedArticles: _.get(state, 'dataSources.relatedArticles'),
  summaries: _.get(state, 'dataSources.summaries'),
  country: state.country,
});

@connect(mapStateToProps)
export default class Articles extends React.PureComponent {

  render() {
    const { mainArticle, relatedArticles, summaries, country } = this.props;
    const articles = (mainArticle || []).concat(relatedArticles || []);

    const hasArticles = articles && articles.length && articles[0] !== null;

    /* Use the main article's first competition tag as CSID for all subsequent articles
       we don't want ad conflicts due to mixing competitions in the same feed */
    const csidCompetition = _.get(articles[0], 'tags.competitions[0].en.slug', '');

    return (
      <section className="article-page">
        {
          hasArticles ?
            <div>
              {
                articles.map((article, index) => {
                  const firstArticle = (index === 0);
                  const autoplay = firstArticle && _.get(article, 'settings.autoPlayFirstVideo');
				  if (_.isEmpty(article)) {
                    return firstArticle ? <NoMatch /> : null;
                  }
					//autoplay={autoplay} //autoplay={true}
                  return (
                    <div key={article.id}>
                    <Article article={article} firstArticle={firstArticle} autoplay={autoplay} csidCompetition={csidCompetition} />
                      { firstArticle && !_.isEmpty(summaries) && <VideoSummaries summaries={summaries} country={country} />}
                    </div>
                  );
                })
              }
            </div>
          :
            <Loader />
        }
      </section>
    );
  }
}

Articles.propTypes = {
  articles: React.PropTypes.array,
  config: React.PropTypes.object,
  routeParams: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/ArticleList.jsx